import * as Sentry from '@sentry/browser';

const Promise = require('bluebird');

export function initializeMParticle(apiKey) {
  if (!apiKey || typeof mParticle === 'undefined') {
    return Promise.resolve();
  }
  return new Promise(resolve => {
    let isReady = false;
    const timeoutId = setTimeout(() => {
      if (!isReady) {
        // Report to Sentry if mParticle hasn't loaded in 1 minute
        Sentry.captureException(
          new Error(`mParticle failed to load within 1 minute`)
        );
      }
    }, 60000);

    window.mParticle.ready(() => {
      isReady = true;
      clearTimeout(timeoutId);
      resolve();
    });

    loadMParticleScript(apiKey);
  });
}

/**
 * Expects mParticle snippet to be half run in the page HTML
 * (reactClient.ejs)
 * https://docs.mparticle.com/developers/sdk/javascript/getting-started/#2-include-the-snippet-in-your-project
 */
function loadMParticleScript(apiKey) {
  const mp = document.createElement('script');
  mp.type = 'text/javascript';
  mp.async = true;
  mp.src = `${
    document.location.protocol === 'https:'
      ? 'https://jssdkcdns'
      : 'http://jssdkcdn'
  }.mparticle.com/js/v2/${apiKey}/mparticle.js`;
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(mp, s);
}
